import React from "react";
import logo from "../assets/images/logo.png";
import { adminSideBar, registerSideBar, renewSideBar } from "./SidebarConfig";
import { useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { PROCESS_STEPS, RENEW_STEPS } from "../config/constant";

export default function Sidebar() {
  const {step} = useParams();
  const {token, user} = useSelector((state) => state.auth);
  const {pathname} = useLocation();
  const stepList = (token && user?.id && !pathname.includes("upgrade")) ? RENEW_STEPS : PROCESS_STEPS;

  function getSideBarConfig() {
    return (token && user?.id && !pathname.includes("upgrade")) ? renewSideBar : (pathname.includes("admin") ? adminSideBar : registerSideBar); 
  }

  const sidebarOptions = getSideBarConfig();

  return (
    <aside className="sideBar">
      <div>
        <span>
          {" "}
          <img src={logo} alt="" className="logo" />{" "}
        </span>

        <ul className="stepsRow">
          {sidebarOptions.map((item, index) => {
            let className =
              index === stepList.indexOf(step)
                ? "active"
                : index < stepList.indexOf(step) + 1
                ? "complete"
                : "";
            
            if((pathname.includes("payment-success") || pathname.includes("thank-you")) && index === sidebarOptions.length - 1){
              className = "complete";
            }
            return (
              <li key={item} className={className}>
                <span className="count">{index + 1}</span> {item}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="sidebarFooter">
        <p>Steps Completed</p>
        <div className="stepsCount">
          <span>{(pathname.includes("payment-success") || pathname.includes("thank-you")) ? sidebarOptions.length : stepList.indexOf(step)}</span> Out of {sidebarOptions.length}
        </div>
      </div>
    </aside>
  );
}
